<input [(ngModel)]="valueSearch" type="text" style="height: 25px;"
       (ngModelChange)="findData()" [fieldSize]="'tiny'" nbInput fieldSize="small"
       placeholder="in" [placeholder]="inputSearchData.placeholder">&nbsp;
<button  class="animate__animated animate__backInRight" style="height: 25px;"
         *ngIf="valueSearch.length > 0" (click)="clearData()"
         [status]="'danger'" [shape]="'rectangle'"
         [size]="'tiny'" nbButton>
  <span style="color: #ffffff;font-weight: bold;font-size: medium;">X</span></button>

